import { createSlice } from "@reduxjs/toolkit"

var initialState={
  userName:''
}

const userReducer = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    registerUser(state, action) {
      state.userName=action.payload
    },
    loginUser(state, action) {
      state.userName=action.payload
    },
    logOutUser(state, action) {
      state.userName=''
    },
  },
})

export const { registerUser, loginUser, logOutUser } = userReducer.actions
export default userReducer